import React from 'react'
import {Field} from 'redux-form'
import {childrenBirthYear} from './childrenBirthYear'

/**
 * @param {{}} props
 * @returns {JSX.Element}
 */
export const childrenBirthYearsArray = (props) => {

	const {
		fields,
		t,
		meta: {error}
	} = props

	return (

    <div>

      <button className="btn btn-sm btn-secondary btn-add-person"
              type="button"
              onClick={() => fields.push('')}>
        <i className="abl-icon-plus"/>
        &nbsp;
        {t('action.addChild')}
      </button>

      <div className="form-group row row-child">

        {
          fields.map((fieldPath, index) => {

            return (
              <div key={index} className="col-md-6">
                <label>
                  {t('application.birthYear')}
                </label>
                <Field name={fieldPath}
                       component={childrenBirthYear}
                       onClick={() => fields.remove(index)}
                       placeholder={t('application.childrenBirthYearsPlaceHolder')}
                       label={''}/>
              </div>
            )
          })
        }
      </div>
      <p className="small text-muted">
        Bitte bei Schwangerschaft oder Kindern älter als 18 Jahre in Erstausbildung bis zum Anmeldeschluss <strong>unaufgefordert</strong> und bei <strong>jeder</strong> Bewerbung eine Bestätigung (Arztzeugnis, Studienbestätigung) per E-Mail an <a href="mailto:wohnungsvergabe@abl.ch">wohnungsvergabe@abl.ch</a> einreichen.
      </p>
    </div>
	)
}
